const formatCurrency = (value) => (value === null || value === undefined ? '—' : `₹ ${Number(value).toLocaleString('en-IN')}`);

// Header/cell text is single-line + ellipsis by the shared table's CSS (not something to
// change globally), so a column has to be sized to its own content to actually show it in
// full - department names in particular ("Operations Growth Department (OGD)") need real
// room, while Slot never does. `padding` covers the freeze-pin button and sort arrows that
// share the header cell with the label text.
const widthForCharLength = (charLength, { min = 90, max = 400, charPx = 8, padding = 72 } = {}) =>
  Math.min(max, Math.max(min, Math.round(charLength * charPx + padding)));

const longestValueLength = (rows, field) =>
  rows.reduce((longest, row) => Math.max(longest, String(row[field] ?? '').length), 0);

export const targetManagementTableHeader = (renderAction, rows = []) => {
  const nameWidth = widthForCharLength(Math.max('Name'.length, longestValueLength(rows, 'name')));
  const deptWidth = widthForCharLength(Math.max('Department'.length, longestValueLength(rows, 'deptName')));
  const wingWidth = widthForCharLength(Math.max('Wing'.length, longestValueLength(rows, 'wingName')));
  const maxTarget = Math.max(0, ...rows.map((r) => Number(r.target) || 0));
  const targetWidth = widthForCharLength(
    Math.max('Target (this month)'.length, formatCurrency(maxTarget).length),
  );

  return [
    { field: 'name', headerName: 'Name', width: nameWidth, sortable: true },
    { field: 'deptName', headerName: 'Department', width: deptWidth, sortable: true },
    { field: 'wingName', headerName: 'Wing', width: wingWidth, sortable: true },
    {
      field: 'target',
      headerName: 'Target (this month)',
      width: targetWidth,
      align: 'right',
      sortable: true,
      valueGetter: ({ value }) => formatCurrency(value),
    },
    { field: 'slot', headerName: 'Slot', width: 90, align: 'right', sortable: true },
    {
      field: 'action',
      headerName: '',
      width: 140,
      renderCell: renderAction,
    },
  ];
};
